import * as React from "react"
import { slugify } from "../../custom_utils/helpers"
import { ImageBlock } from "./image_block"
import { LinkButton } from "./library/button"
import { Link } from "./library/link"

export interface FeaturedContentBlockProps {
  readonly title: string
  readonly html: string
  readonly linkTitle: string
  readonly linkUrl: string
  readonly imageUrl: string
  readonly imageAlt: string
}

export const FeaturedContentBlock = (props: FeaturedContentBlockProps) => (
  <div className="featured-content-block">
    <div className="featured-content-block__text">
      <header className="featured-content-block__header">        
        <h2 data-anchor={slugify(props.title)} className="featured-content-block__title title--l">{props.title}</h2>
        <p className="featured-content-block__label"><span className="sr-text">Categorie: </span>Uitgelicht</p>
      </header>

      <div dangerouslySetInnerHTML={{ __html: props.html }} />

      <footer className="featured-content-block__footer">
        <LinkButton variant="black" route={props.linkUrl}>{props.linkTitle}</LinkButton>
      </footer>
    </div>

    <div className="featured-content-block__image">
      <ImageBlock imageUrl={props.imageUrl} imageAlt={props.imageAlt} />
    </div>
  </div>
)
